import axios from 'axios'
import store from '../store'

export default {
  methods: {
    async getExportgroupById(exportgroupId = 0) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/${exportgroupId}`,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },

    async getExportgroupItems(exportgroupId = 0) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/${exportgroupId}/items`,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },

    async getLocationExportgroups(locationId = 0) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/location/${locationId}`,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },

    async createExportgroups(locationId = 0, name = '') {
      let criteria = {
        Name: name,
        LocationId: locationId
      }

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup`,
        criteria,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },

    async createExportgroupsBulk(locationId = 0, data) {
      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/location/${locationId}/bulk`,
        data,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },

    async deleteExportgroups(exportgroupId = 0, transferTo = 0) {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/${exportgroupId}`,
        {
          params: {
            transferTo: transferTo
          },
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },
    async editExportgroups(exportgroupId = 0, name = '') {
      let criteria = {
        Name: name
      }
      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/${exportgroupId}`,
        criteria,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },
    async transferExportgroupAll(exportgroupId = 0, transferTo = 0) {
      let criteria = {
        transferTo: transferTo
      }

      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/${exportgroupId}/transfer/all`,
        criteria,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },
    async transferExportgroupSelect(
      exportgroupId = 0,
      itemTransferSelection = []
    ) {
      let criteria = {
        Items: itemTransferSelection
      }

      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/exportgroup/${exportgroupId}/transfer`,
        criteria,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    }
  }
}
